var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5116 1.12848C13.6558 1.25559 13.7171 1.45253 13.6705 1.63903L10.9277 12.6104C10.8827 12.7902 10.7446 12.9319 10.566 12.9813C10.3874 13.0308 10.1961 12.9804 10.0651 12.8494L7.0558 9.84009L5.35445 12.1086C5.23968 12.2616 5.04946 12.3383 4.86064 12.3076C4.67182 12.277 4.51562 12.1441 4.45513 11.9626L3.15106 8.05044L0.598746 6.77428C0.416803 6.68331 0.305578 6.49364 0.315009 6.29044C0.32444 6.08724 0.452754 5.9087 0.64234 5.83497L12.9852 1.03498C13.1643 0.965301 13.3674 1.00137 13.5116 1.12848ZM7.37009 8.69976C7.36628 8.69583 7.3624 8.69195 7.35844 8.68812L7.04175 8.37143L9.42095 5.99223C9.62179 5.79139 9.62179 5.46576 9.42095 5.26492C9.22011 5.06408 8.89448 5.06408 8.69364 5.26492L5.95079 8.00777C5.74995 8.20861 5.74995 8.53424 5.95079 8.73508L6.32111 9.1054L5.12052 10.7062L4.05949 7.52308C4.01635 7.39368 3.92359 7.28672 3.80159 7.22572L2.09638 6.37312L12.4316 2.35388L10.1501 11.4798L7.37009 8.69976Z",
    fill: "#7043FF",
    stroke: "#7043FF",
    strokeWidth: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send_message.e00b837e2c77e69bef7b1b3ff495e64d.svg";
export { ForwardRef as ReactComponent };